<template>
  <div>
    <div class="md-layout" id="tourlistheader">
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>event</md-icon>
            </div>
          </md-card-header>
          <md-card-content :hidden="!loading">
            <div class="md-layout">
              <div class="md-layout-item text-center">
                <md-progress-spinner
                  md-mode="indeterminate"
                  :md-diameter="spinnerDiameter"
                  :md-stroke="spinnerStroke"
                ></md-progress-spinner>
              </div>
            </div>
          </md-card-content>
          <md-card-content :hidden="loading">
            <md-table>
              <md-table-row>
                <md-table-head class="md-medium-hide">Datum</md-table-head>
                <md-table-head>Titel</md-table-head>
                <md-table-head class="md-xsmall-hide">Plats</md-table-head>
                <md-table-head class="md-medium-hide">Arrangör</md-table-head>
                <md-table-head class="md-small-hide">Status</md-table-head>
                <md-table-head class="md-medium-hide"
                  >Ansökningar</md-table-head
                >
                <md-table-head class="text-right"></md-table-head>
              </md-table-row>
              <md-table-row v-for="item in paginatedData" v-bind:key="item.id">
                <md-table-cell class="md-medium-hide">{{
                  item.date
                }}</md-table-cell>
                <md-table-cell>{{ item.title }}</md-table-cell>
                <md-table-cell class="md-xsmall-hide">{{
                  item.location | capitalize
                }}</md-table-cell>
                <md-table-cell class="md-medium-hide">{{
                  item.organizers.map(o => o.organizer).join(", ")
                }}</md-table-cell>
                <md-table-cell class="md-small-hide">
                  <span v-if="item.status == 'planerad'">
                    <md-icon>timer</md-icon>
                    <md-tooltip md-direction="right">Pågående</md-tooltip>
                  </span>
                  <span v-if="item.status == 'avslutad'">
                    <md-icon>done</md-icon>
                    <md-tooltip md-direction="right">Avklarat</md-tooltip>
                  </span>
                  <span v-if="item.status == 'inställd'">
                    <md-icon>block</md-icon>
                    <md-tooltip md-direction="right">Inställt</md-tooltip>
                  </span>
                  <span v-if="item.status == 'utkast'">
                    <md-icon>edit</md-icon>
                    <md-tooltip md-direction="right">Utkast</md-tooltip>
                  </span>
                </md-table-cell>
                <md-table-cell class="md-medium-hide">
                  {{ item.applications }} st</md-table-cell
                >
                <md-table-cell class="action-box-wrapper">
                  <div class="action-box">
                    <div>
                      <md-button
                        class="md-just-icon md-success"
                        :to="{ path: '/tour/' + item.id + '/mail' }"
                        v-if="
                          isAuthorizedToReadArrangementMail(item) ||
                            isAuthorizedToWriteArrangementMail(item)
                        "
                        ><md-icon>email</md-icon></md-button
                      >
                    </div>
                    <div>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="pdfUrl(item.id)"
                      >
                        <md-button class="md-just-icon md-info"
                          ><md-icon>picture_as_pdf</md-icon></md-button
                        >
                      </a>
                    </div>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div class="md-layout text-center pagination-button-container">
              <div class="md-layout-item">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-button
                      class="pagination-button md-just-icon md-success"
                      :disabled="currentPage == 1"
                      @click="firstPage"
                      ><md-icon>first_page</md-icon></md-button
                    >
                    &nbsp;
                    <md-button
                      class="pagination-button md-just-icon md-success"
                      :disabled="currentPage == 1"
                      @click="previousPage"
                      ><md-icon>skip_previous</md-icon></md-button
                    >
                    &nbsp;
                    <md-button
                      class="pagination-button md-just-icon md-success"
                      :disabled="currentPage == totalPages"
                      @click="nextPage"
                      ><md-icon>skip_next</md-icon></md-button
                    >
                    &nbsp;
                    <md-button
                      class="pagination-button md-just-icon md-success"
                      :disabled="currentPage == totalPages"
                      @click="lastPage"
                      ><md-icon>last_page</md-icon></md-button
                    >
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <p>Sida {{ currentPage }} av {{ totalPages }}</p>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      data: [],
      spinnerDiameter: 60,
      spinnerStroke: 6,
      loading: true,
      offset: 0,
      limit: 10
    };
  },
  mounted: function() {
    this.loadData();
  },
  computed: {
    isAuthorizedToRead: function() {
      return this.$store.getters.roles.includes("arrangement_read");
    },
    isAuthorizedToReadArrangementEmails: function() {
      return this.$store.getters.mailRoles.includes("read_arrangement");
    },
    isAuthorizedToWriteArrangementEmails: function() {
      return this.$store.getters.mailRoles.includes("write_arrangement");
    },
    paginatedData: function() {
      return this.data.slice(this.offset).slice(0, this.limit);
    },
    currentPage: function() {
      return Math.ceil(this.offset / this.limit) + 1;
    },
    totalPages: function() {
      return Math.ceil(this.data.length / this.limit);
    }
  },
  methods: {
    pdfUrl: function(id) {
      return "https://pdf.svbefs.se/?arrangement=" + id;
    },
    nextPage: function() {
      this.offset += this.limit;
    },
    previousPage: function() {
      this.offset -= this.limit;
    },
    firstPage: function() {
      this.offset = 0;
    },
    lastPage: function() {
      this.offset = Math.floor(this.data.length / this.limit) * this.limit;
    },
    setError: function(text) {
      this.$notify({
        message: text,
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
        timeout: 5000
      });
    },
    loadData: function() {
      if (!this.isAuthorizedToRead) {
        this.setError("Du har inte behörighet för denna sida!");
        return;
      }
      this.loading = true;
      this.axios
        .get("internal/arrangement")
        .then(response => {
          let parsedData = [];
          response.data.sort((x, y) =>
            moment.utc(y.date).diff(moment.utc(x.date))
          ).forEach(function(item) {
            parsedData.push({
              id: item.id,
              title: item.title,
              location: item.location,
              status: item.status,
              date: item.date,
              organizer: item.organizer,
              organizers: item.organizers,
              applications: item.applications
            });
          });
          this.data = parsedData;
          this.loading = false;
        })
        .catch(() => {
          this.setError("Något gick fel");
        });
    },
    isAuthorizedToReadArrangementMail: function(arrangement) {
      return (
        this.$store.getters.mailRoles.includes("administrator") ||
        (this.$store.getters.mailRoles.includes("read_arrangement") &&
          arrangement.organizers
            .map(o => o.organizer)
            .includes(this.$store.getters.userName))
      );
    },
    isAuthorizedToWriteArrangementMail: function(arrangement) {
      return (
        this.$store.getters.mailRoles.includes("administrator") ||
        (this.$store.getters.mailRoles.includes("send_arrangement") &&
          arrangement.organizers
            .map(o => o.organizer)
            .includes(this.$store.getters.userName))
      );
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>
<style lang="scss" scoped>
//.text-right /deep/ .md-table-cell-container {
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}
.action-box-wrapper {
  position: relative;
}
.action-box {
  display: flex;
  flex-direction: row;
}
.md-just-icon {
  margin-left: 3px;
  margin-right: 3px;
}
//.md-table /deep/ .md-table-head:last-child {
.md-table .md-table-head:last-child {
  text-align: right;
}
.pagination-button-container {
  padding-top: 20px;
}
.pagination-button {
  margin: 0;
  padding: 5px;
  height: 27px;
  min-width: 27px;
  width: 27px;
  line-height: 27px;
}
#tourlistheader .md-button {
  float: right;
}
</style>
